import { Outlet } from "@tanstack/react-router";

import { AppSidebar } from "../AppSidebar";
import { AuthenticationDialog } from "../AuthenticationDialog";

export default function PunttLayout() {
  // Hooks go here if we need them

  /////
  // No hooks beyond this point
  /////

  return (
    <main className="relative grid h-screen grid-cols-[auto_1fr] overflow-hidden bg-puntt-neutral-gray-2">
      <AuthenticationDialog />

      <AppSidebar />

      <div
        className="min-h-0 min-w-0 overflow-hidden"
        data-testid="puntt-outlet-shell"
      >
        <Outlet />
      </div>
    </main>
  );
}
